/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Feature_Api_DescriptionInputs */

const en_marketing_feature_api_description = /** @type {(inputs: Marketing_Feature_Api_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contract-first oRPC with API keys, OpenAPI docs, a typed npm client, and a CLI.`)
};

const es_marketing_feature_api_description = /** @type {(inputs: Marketing_Feature_Api_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oRPC con contrato primero, claves de API, documentación OpenAPI, un cliente npm tipado y una CLI.`)
};

const fr_marketing_feature_api_description = /** @type {(inputs: Marketing_Feature_Api_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oRPC orienté contrat avec clés d'API, documentation OpenAPI, un client npm typé et une CLI.`)
};

/**
* | output |
* | --- |
* | "Contract-first oRPC with API keys, OpenAPI docs, a typed npm client, and a CLI." |
*
* @param {Marketing_Feature_Api_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_feature_api_description = /** @type {((inputs?: Marketing_Feature_Api_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Feature_Api_DescriptionInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_feature_api_description(inputs)
	if (locale === "es") return es_marketing_feature_api_description(inputs)
	return fr_marketing_feature_api_description(inputs)
});